/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const isCheckAllGroupValues = (listGroup: any, listSelected:any) => {
  let total = listGroup?.length || 0;
  return listSelected && listSelected.length === total;
};

export const getAllStatusValuesByGroup = (status:boolean, baseList:Array<any>) => {
  let isChecked = status;
  let listValues = [];
  if (isChecked) {
    listValues =  baseList.map((item:any) => {
      return item.actionId;
    });
  }
  return listValues;
}

export const updatePivoteData = (pivoteList: Array<any>, groupPos: number, checked: boolean, indeterminate: boolean) => {
  let updatedList:any = pivoteList;
  updatedList[groupPos].indeterminate = indeterminate;
  updatedList[groupPos].checked = checked;
  return [...updatedList];
};

export const getPivoteListByGroup = (listSelected:any, list: any, groupPos:number, pivoteList: Array<any>) => {
  let pivoteListByGroup:any = [];
  if (isCheckAllGroupValues(list, listSelected)) {
    pivoteListByGroup = updatePivoteData(pivoteList, groupPos, true, false);
  } else {
    if (!listSelected || listSelected?.length === 0) {
      pivoteListByGroup = updatePivoteData(pivoteList, groupPos, false, false);
    } else {
      pivoteListByGroup = updatePivoteData(pivoteList, groupPos, false, true);
    }
  }
  return pivoteListByGroup;
}

export const getUpdateRoles = (currentList:Array<any>, newRoles:Array<any>, serviceId:string, licenseId:string) => {
  let listAll:any = JSON.parse(JSON.stringify(currentList));
  if (newRoles) {
    let indexLicense = listAll?.findIndex((item:any) => item.licenseId === licenseId);
    if (indexLicense >= 0) {
      let indexService = listAll[indexLicense]?.applications?.findIndex((item:any) => item.serviceId === serviceId);
      if (indexService >= 0) {
        listAll[indexLicense].applications[indexService].roles = [...newRoles];
      } else {
        listAll[indexLicense].applications.push({
          serviceId: serviceId,
          roles: [...newRoles],
        });
      }
    } else {
      listAll.push({
        licenseId: licenseId,
        applications: [
          {
            serviceId: serviceId,
            roles: [...newRoles],
          }
        ]
      });
    }
  }
  return listAll;
};

export const getUpdatedRolOnList = (currentList:Array<any>, role:any, serviceId:string, licenseId:string)  => {
  let listAll:any = JSON.parse(JSON.stringify(currentList));
  let indexLicense = listAll?.findIndex((item:any) => item.licenseId === licenseId);
  if (indexLicense >= 0) {
    let indexService = listAll[indexLicense]?.applications?.findIndex((item:any) => item.serviceId === serviceId);
    if (indexService >= 0) {
      let indexRol = listAll[indexLicense].applications[indexService].roles?.findIndex((item:any) => item.roleId === role?.roleId);
      if (indexRol >= 0) {
        listAll[indexLicense].applications[indexService].roles[indexRol] = {...role};
      }
    }
  }
  return listAll;
};

export const getUpdateRolesPermissions = (currentList:Array<any>, newRoles:any, serviceId:string, licenseId:string) => {
  let listAll:any = JSON.parse(JSON.stringify(currentList));
  if (newRoles && Object.keys(newRoles)?.length > 0) {
    let indexLicense = listAll?.findIndex((item:any) => item.licenseId === licenseId);
    if (indexLicense >= 0) {
      let indexService = listAll[indexLicense]?.applications?.findIndex((item:any) => item.serviceId === serviceId);
      if (indexService >= 0) {
        listAll[indexLicense].applications[indexService].roles = {...newRoles};
      } else {
        listAll[indexLicense].applications.push({
          serviceId: serviceId,
          roles: {...newRoles},
        });
      }
    } else {
      listAll.push({
        licenseId: licenseId,
        applications: [
          {
            serviceId: serviceId,
            roles: {...newRoles},
          }
        ]
      });
    }
  }
  return listAll;
};

export const getUpdateRolesPermissionsMassive = (currentList:Array<any>, updatedList: Array<any>) => {
  let permissionList = currentList;
  if (updatedList?.length > 0) {
    updatedList.forEach((el:any) => {
      permissionList = [
        ...getUpdateRolesPermissions(permissionList, el.roles, el.serviceId, el.licenseId)
      ]
    });
  } 
  return permissionList;
};

export const hasCustomPermission = (serviceId:string, licenseId:string, permission:string, permissionList:any) => {
  let hasPermission = false;
  let indexLicense = permissionList?.findIndex((item:any) => item.licenseId === licenseId);
  if (indexLicense >= 0) {
    let indexService = permissionList[indexLicense]?.applications?.findIndex((item:any) => item.serviceId === serviceId);
    if (indexService >= 0) {
      hasPermission = permissionList[indexLicense].applications[indexService].roles[permission] || false;
    }
  }
  return hasPermission;
};

export const isSettingPermission = (serviceId:string, licenseId:string, permissionList:any) => {
  let isSetting = false;
  let indexLicense = permissionList?.findIndex((item:any) => item.licenseId === licenseId);
  if (indexLicense >= 0) {
    let indexService = permissionList[indexLicense]?.applications?.findIndex((item:any) => item.serviceId === serviceId);
    if (indexService >= 0) {
      if (permissionList[indexLicense].applications[indexService].roles) {
        isSetting = true;
      }
    }
  }
  return isSetting;
};

export const hasChangePermissions = (currentPermissions:Array<any>, updatedPermissions:Array<any>) => {
  let hasChange = false;
  let updatedResourcesIds = updatedPermissions?.map((el:any)=> { return el.resourceId; })?.sort();
  let currentResourcesIds = currentPermissions?.map((el:any)=> { return el.resourceId; })?.sort();
  if (updatedResourcesIds?.length !== currentResourcesIds?.length) {
    return true;
  } else {
    if(!currentResourcesIds.every((value, index) => value === updatedResourcesIds[index])) {
      return true;
    } else {
      updatedPermissions?.forEach((el:any) => {
        let currentActions = currentPermissions?.find((it:any) => it.resourceId === el.resourceId)?.actionIds?.sort() || [];
        let updatedActions = el.actionIds?.sort() || [];
        if (currentActions?.length !== updatedActions?.length) {
          hasChange = true;
        } else {
          if (!currentActions.every((act:any, i:number) => act === updatedActions[i])) {
            hasChange = true;
          }
        }
      });
    }
  }
  return hasChange;
};

export const isRoleUpdated = (roles:Array<any>, role:any, serviceId:string, licenseId:string) => {
  let isUpdated = true;
  let listAll:any = JSON.parse(JSON.stringify(roles));
  if (role) {
    let indexLicense = listAll?.findIndex((item:any) => item.licenseId === licenseId);
    if (indexLicense >= 0) {
      let indexService = listAll[indexLicense]?.applications?.findIndex((item:any) => item.serviceId === serviceId);
      if (indexService >= 0) {
        let currentRol = listAll[indexLicense].applications[indexService].roles?.find((rol:any)=> rol.roleId === role.roleId);
        if (currentRol) {
          if (currentRol?.roleName === role?.roleName && currentRol?.roleAlias === role?.roleAlias && !hasChangePermissions(currentRol?.permissions, role?.permissions)) {
            isUpdated = false;
          }
        }
      }
    }
  }
  return isUpdated;
};
